export default function normalizeLocation(loc, searchTerm) {
	// if it's US, metro_code will be set, so use the state name, otherwise use non-US country name
	searchTerm = searchTerm ? String(searchTerm).trim() : '';

	const state = loc.metro_code ? loc.subdivision_1_iso_code : loc.country_name,
		name = `${loc.city_name}, ${state}`;
	return Object.assign({}, loc, {
		name,
		city: loc.city_name,
		state,
		geoname_id: loc.geoname_id, //guard
		postal_code: loc.postal_code, //guard
		matched_postal_code: loc.postal_code
			&& loc.postal_code[loc.postal_code.indexOf(searchTerm)], // if we queried an exact ZIP code
		query: searchTerm, //what got us here
		id: `${name}|${loc.geoname_id}`
	});
}
